import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.scss";
import Layout from "./components/Layout/Layout";
import Sidebar from "./components/Sidebar/Sidebar";
import CursorCanvas from "./components/CursorCanvas/CursorCanvas";
import Main from "./components/Main/Main";
import Loader from "./components/Loader/Loader";

function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [location.pathname]); 

  return (
    <>
      {loading && <Loader />}
      <CursorCanvas />
      <Sidebar />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Main />} />
          <Route path="about" element={<Main />} />
          <Route path="contact" element={<Main />} />
          <Route path="skill" element={<Main />} />
          <Route path="experience" element={<Main />} />
          <Route path="project" element={<Main />} />
          <Route path="achievements" element={<Main />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
